import {gsap} from "gsap";
// import {DrawSVGPlugin} from "gsap/DrawSVGPlugin";
// import {MorphSVGPlugin} from "gsap/MorphSVGPlugin";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

jQuery(document).ready(function () {
    let controlit = jQuery('.sprite-icon-menu-burger');
    let menuToggle = gsap.timeline({paused: true, reversed: true});
    menuToggle
        .fromTo(' .burger-line-middle', {}, {attr: {stroke:''}})
        .fromTo(' .burger-line-top', {}, {attr: {x1: 8, y1: 8, x2: 24, y2: 24}})
        .fromTo(' .burger-line-bottom', {}, {attr: {x1: 24, y1: 8, x2: 8, y2: 24}})

    controlit.click(function () {
        menuToggle.reversed() ? menuToggle.restart() : menuToggle.reverse();
    });

    let sticky_header = jQuery('.sticky-header');
    let tl_sticky_header = gsap.timeline({
        scrollTrigger: {
            trigger: sticky_header,
            start: "top -100",
            end: 99999,
            toggleActions: "play reverse",
        }
    });
    tl_sticky_header.to(jQuery('body'), {paddingTop: sticky_header.height(), duration: 0});
    tl_sticky_header.to(sticky_header, {className: 'sticky--scrolled'})
});
